module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Mangrove Sands – "), _c('br'), _vm._v("The Enchanted "), _c('br'), _vm._v("Sea World")]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#introduction"
    }
  }, [_vm._v("Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-1-expect-the-unexpected"
    }
  }, [_vm._v("Chapter 1: Expect the Unexpected")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-2-power-of-the-mind"
    }
  }, [_vm._v("Chapter 2: Power of the Mind")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-3-magical-new-discoveries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Magical New Discoveries")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-4-the-tsunami-rescue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Tsunami Rescue")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-5-the-green-slime-cure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Green Slime Cure")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-6-shark-nets-and-herrings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Shark Nets and Herrings")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-7-the-realm-of-horror",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Realm of Horror")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-8-revelations-and-nespoon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Revelations and Nespoon")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-9-magical-spoons-and-cyclone-sally",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Magical Spoons and Cyclone Sally")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-10-end-of-an-era",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: End of an Era")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-11-the-final-farewell",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Final Farewell")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0